/**
 * Beneficios en tarjeta Oleum: acordeón vertical + iconos por colección.
 */
(function () {
  var CATEGORIES = [
    {
      id: 'emocional',
      label: 'Bienestar emocional',
      icon: 'icon-bienestar-emocional.svg',
      handles: ['bienestar-emocional'],
      signals: ['bienestar_personal', 'equilibrio_emocional', 'consumer', 'emocional', 'bienestar']
    },
    {
      id: 'skincare',
      label: 'Skincare',
      icon: 'icon-skincare.svg',
      handles: ['skincare', 'skincare-para-el-y-ella'],
      signals: ['skincare_user', 'haircare_user', 'cuidado_piel', 'belleza']
    },
    {
      id: 'corporal',
      label: 'Bienestar corporal',
      icon: 'icon-bienestar-corporal.svg',
      handles: ['bienestar-corporal'],
      signals: ['bienestar_corporal', 'body_wellness']
    },
    {
      id: 'alimentos',
      label: 'Alimentos y bebidas',
      icon: 'icon-alimentos-y-bebidas.svg',
      handles: ['alimentos-y-bebidas'],
      signals: ['gastronomia', 'gastronomia_bebidas', 'culinary', 'mixologist', 'comestible', 'alimentos']
    },
    {
      id: 'hogar',
      label: 'Hogar y espacios',
      icon: 'icon-hogar-y-espacios.svg',
      handles: ['hogar-y-espacios'],
      signals: ['hogar_espacios', 'aroma_hogar', 'home_user', 'sensory_space', 'aromatizacion']
    }
  ];

  function normalizeToken(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/-/g, '_')
      .trim();
  }

  function addTokensToSet(set, input) {
    if (!input) return;
    if (Array.isArray(input)) {
      for (var i = 0; i < input.length; i++) {
        var token = normalizeToken(input[i]);
        if (token) set[token] = true;
      }
      return;
    }
    var single = normalizeToken(input);
    if (single) set[single] = true;
  }

  function parseMetafieldList(mf) {
    if (!mf || mf.value == null || mf.value === '') return [];
    var raw = mf.value;
    if (Array.isArray(raw)) return raw;
    if (typeof raw === 'string') {
      if (raw.indexOf('|') !== -1) return raw.split('|');
      if (raw.indexOf(',') !== -1) return raw.split(',');
      try {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) return parsed;
      } catch (e) {}
      return [raw];
    }
    return [];
  }

  function handleSetFromInput(input) {
    var set = {};
    if (!input) return set;
    if (!Array.isArray(input)) return set;
    for (var i = 0; i < input.length; i++) {
      var item = input[i];
      if (typeof item === 'string' && item) {
        set[item.toLowerCase()] = true;
      } else if (item && item.handle) {
        set[String(item.handle).toLowerCase()] = true;
      }
    }
    return set;
  }

  function getOleumMatchedBeneficios(collectionHandles, categoryMeta) {
    var tokens = {};
    var handles = handleSetFromInput(collectionHandles);
    Object.keys(handles).forEach(function (handle) {
      addTokensToSet(tokens, handle);
    });

    categoryMeta = categoryMeta || {};
    addTokensToSet(tokens, categoryMeta.routes);
    addTokensToSet(tokens, categoryMeta.profiles);
    addTokensToSet(tokens, categoryMeta.intents);
    addTokensToSet(tokens, categoryMeta.tags);

    var matched = [];
    for (var c = 0; c < CATEGORIES.length; c++) {
      var cat = CATEGORIES[c];
      var found = false;
      for (var h = 0; h < cat.handles.length; h++) {
        if (handles[cat.handles[h].toLowerCase()]) {
          found = true;
          break;
        }
      }
      if (!found && cat.signals) {
        for (var s = 0; s < cat.signals.length; s++) {
          if (tokens[cat.signals[s]]) {
            found = true;
            break;
          }
        }
      }
      if (found) matched.push(cat);
    }
    return matched;
  }

  function initOleumCardBeneficiosIn(root) {
    (root || document).querySelectorAll('[data-card-beneficios]').forEach(function (block) {
      if (block.dataset.beneficiosBound === '1') return;
      block.dataset.beneficiosBound = '1';

      var cta = block.querySelector('[data-beneficios-cta]');
      var panel = block.querySelector('[data-beneficios-panel]');
      var scrollEl = block.querySelector('[data-beneficios-scroll]');
      var trackEl = scrollEl ? scrollEl.querySelector('[data-beneficios-track]') : null;

      if (scrollEl && !trackEl) {
        trackEl = document.createElement('div');
        trackEl.className = 'card-beneficios__track';
        trackEl.setAttribute('data-beneficios-track', '');
        while (scrollEl.firstChild) {
          trackEl.appendChild(scrollEl.firstChild);
        }
        scrollEl.appendChild(trackEl);
      }

      var items = trackEl ? trackEl.querySelectorAll('[data-beneficio-item]') : block.querySelectorAll('[data-beneficio-item]');
      var prefersReducedMotion =
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var activeSlideItem = null;

      function setTrackOffset(px) {
        if (!trackEl) return;
        trackEl.style.transform = px > 0 ? 'translateX(-' + px + 'px)' : '';
      }

      function getSlideOffsetForItem(item) {
        if (!trackEl || !item) return 0;
        var index = Array.prototype.indexOf.call(items, item);
        if (index <= 0) return 0;

        var gapValue = window.getComputedStyle(trackEl).columnGap || window.getComputedStyle(trackEl).gap || '16px';
        var gap = parseFloat(gapValue) || 16;
        var offset = 0;

        for (var i = 0; i < index; i++) {
          offset += items[i].getBoundingClientRect().width;
          offset += gap;
        }

        return offset;
      }

      function slideActiveItemToStart(item) {
        if (!trackEl || !item) return;
        activeSlideItem = item;

        function apply() {
          if (activeSlideItem !== item) return;
          setTrackOffset(getSlideOffsetForItem(item));
        }

        apply();
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(apply);
        });
        window.setTimeout(apply, 300);
      }

      function resetBeneficiosSlide() {
        activeSlideItem = null;
        setTrackOffset(0);
      }

      function getPinnedItem() {
        return block.querySelector('[data-beneficio-pinned="true"]');
      }

      function deactivateAll() {
        items.forEach(function (item) {
          item.classList.remove('is-active');
          item.removeAttribute('data-beneficio-pinned');
          var btn = item.querySelector('[data-beneficio-toggle]');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });
      }

      function setOpen(open) {
        block.classList.toggle('is-open', open);
        if (panel) {
          panel.setAttribute('aria-hidden', open ? 'false' : 'true');
          if (!open) {
            deactivateAll();
            resetBeneficiosSlide();
          }
        }
        if (cta) cta.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      function activateItem(item) {
        items.forEach(function (other) {
          if (other === item) return;
          other.classList.remove('is-active');
          var b = other.querySelector('[data-beneficio-toggle]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        item.classList.add('is-active');
        var btn = item.querySelector('[data-beneficio-toggle]');
        if (btn) btn.setAttribute('aria-expanded', 'true');
        slideActiveItemToStart(item);
      }

      if (scrollEl) {
        scrollEl.addEventListener('mouseleave', function () {
          if (getPinnedItem()) return;
          resetBeneficiosSlide();
        });
      }

      if (typeof ResizeObserver !== 'undefined' && trackEl) {
        var trackResizeObserver = new ResizeObserver(function () {
          if (activeSlideItem && block.classList.contains('is-open')) {
            setTrackOffset(getSlideOffsetForItem(activeSlideItem));
          }
        });
        trackResizeObserver.observe(trackEl);
      }

      if (cta) {
        cta.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          setOpen(!block.classList.contains('is-open'));
        });
      }

      items.forEach(function (item) {
        var toggle = item.querySelector('[data-beneficio-toggle]');
        if (!toggle) return;

        item.addEventListener('mouseenter', function () {
          activateItem(item);
        });

        item.addEventListener('mouseleave', function () {
          if (item.getAttribute('data-beneficio-pinned') === 'true') return;
          item.classList.remove('is-active');
          toggle.setAttribute('aria-expanded', 'false');
          if (!getPinnedItem()) {
            activeSlideItem = null;
          }
        });

        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (item.getAttribute('data-beneficio-pinned') === 'true') {
            item.removeAttribute('data-beneficio-pinned');
            item.classList.remove('is-active');
            toggle.setAttribute('aria-expanded', 'false');
            resetBeneficiosSlide();
          } else {
            items.forEach(function (other) {
              other.removeAttribute('data-beneficio-pinned');
            });
            item.setAttribute('data-beneficio-pinned', 'true');
            activateItem(item);
          }
        });
      });
    });
  }

  function boot() {
    initOleumCardBeneficiosIn(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initOleumCardBeneficiosIn(e.target);
  });

  window.OLEUM_BENEFICIO_CATEGORIES = CATEGORIES;
  window.getOleumMatchedBeneficios = getOleumMatchedBeneficios;
  window.initOleumCardBeneficiosIn = initOleumCardBeneficiosIn;
})();
